export default {
  "content": "<g clip-path=\"url(#clip0_634_31296)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.583 2.167H5.416c-.299 0-.541.242-.541.541v9.75c0 .3.242.542.542.542h2.166c.3 0 .542-.242.542-.542v-9.75c0-.299-.243-.541-.542-.541zM3.25 7.042H1.083c-.299 0-.541.242-.541.541v4.875c0 .3.242.542.541.542H3.25c.299 0 .542-.242.542-.542V7.583c0-.299-.243-.541-.542-.541zm6.5-2.709h2.166c.3 0 .542.243.542.542v7.583c0 .3-.242.542-.542.542H9.75a.542.542 0 01-.542-.542V4.875c0-.3.243-.542.542-.542z\" fill=\"#717684\"/></g><defs><clipPath id=\"clip0_634_31296\"><path fill=\"#fff\" d=\"M0 0h13v13H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "13",
    "height": "13",
    "viewBox": "0 0 13 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};